import ActivityCard from './ActivityCard';
import ActivityCompactCard from './blocks/ActivityCompactCard';
import resolveResizedPhotoLink from './helpers/resolveResizedPhotoLink';
import ActivityCardSkeleton from './blocks/Skeleton';
import LinkWrapper from './blocks/LinkWrapper';
import { formatNumber } from './helpers/formatNumber';
import activityAdapter from './helpers/activityAdapter';
import ActivityCompactCardSkeleton from './blocks/SkeletonCompact';
import { CARD_HEIGHT, CARD_WITH_DESCRIPTION_HEIGHT, COMPACT_CARD_HEIGHT } from './constants';
import { Activity } from './types';
import {
  ActivitiesLikeProps,
  FirstLikeModal,
  FirstLikeModalProps,
  LikesMergeObserver,
} from '@ott/activities-like';

export default ActivityCard;

export { ActivityCardSkeleton, ActivityCompactCard, ActivityCompactCardSkeleton, activityAdapter };

export {
  CARD_HEIGHT,
  CARD_WITH_DESCRIPTION_HEIGHT,
  COMPACT_CARD_HEIGHT,
  LinkWrapper,
  formatNumber,
  resolveResizedPhotoLink,
};

export { FirstLikeModal, LikesMergeObserver };
export type { Activity, ActivitiesLikeProps, FirstLikeModalProps };
